import React from "react";
import { graphql } from "gatsby";
import { motion } from "framer-motion";
import { GatsbyImage } from "gatsby-plugin-image";
import { PrismicRichText } from "@prismicio/react";
import * as styles from "./partners.module.css";

export const Partners = ({ slice }) => {
  const { heading } = slice?.primary || {};

  return (
    <section
      data-color-scheme="paper"
      data-tilt-scheme="center"
      className={styles.section}
      id="partners"
    >
      <div className={"page-width padding-section-vertical " + styles.content}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6, ease: [0.25, 0.1, 0.25, 1] }}
        >
          {heading && (
            <PrismicRichText
              field={heading.richText}
              components={{
                heading2: ({ children }) => <h2 className="h2">{children}</h2>,
              }}
            />
          )}
        </motion.div>
        <ul className={"flex-grid " + styles.list}>
          {slice.items?.map(({ partner_link, partner_logo }, index) => (
            <motion.li
              key={partner_logo.url}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{
                duration: 0.4,
                delay: index * 0.05,
                ease: [0.25, 0.1, 0.25, 1],
              }}
            >
              {partner_logo.gatsbyImageData && partner_link?.url ? (
                <a href={partner_link.url} target="_blank" rel="noreferrer">
                  <GatsbyImage
                    image={partner_logo.gatsbyImageData}
                    alt={partner_logo.alt || ""}
                    objectFit="contain"
                    className={"company-logo " + styles.logo}
                  />
                </a>
              ) : partner_logo.gatsbyImageData ? (
                <GatsbyImage
                  image={partner_logo.gatsbyImageData}
                  alt={partner_logo.alt || ""}
                  objectFit="contain"
                  className={"company-logo " + styles.logo}
                />
              ) : null}
            </motion.li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export const query = graphql`
  fragment HomepageDataBodyPartners on PrismicHomepageDataBodyPartners {
    primary {
      heading {
        richText
      }
    }
    items {
      partner_link {
        url
      }
      partner_logo {
        gatsbyImageData(placeholder: BLURRED)
        url
        alt
      }
    }
  }
`;
